import BackgroundCheckFocusedPage from "@/features/person/components/BackgroundCheckOrders/BackgroundCheckFocusedPage";
import { usePersonMembershipAccess } from "../../person/_usePersonMembershipAccess";

export default function MembershipBackgroundCheckPage() {
  const { loaded, canViewPersonMembership } = usePersonMembershipAccess();

  if (!loaded || !canViewPersonMembership) {
    return null;
  }

  return <BackgroundCheckFocusedPage />;
}
